import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom'
import Emoji from "react-emoji-render";

const csrftoken = document.querySelector("meta[name='csrf-token']").getAttribute("content") 

const Chat = props => {

  const {
    user_key,
    site_key
  } = props

  const [started, setStarted] = useState(false)
  const [visibilityOption, setVisibilityOption] = useState("loading")

  const visibility = useRef(null)
  const pusher = useRef(null)

  const [messages, setMessages] = useState([])
  const [loadingMessages, setLoadingMessages] = useState(true)

  const [message, setMessage] = useState('')
  const [email, setEmail] = useState('')
  const [emailThankYou, setEmailThankYou] = useState(false)
  const [blankEmailError, setBlankEmailError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [height, setHeight] = useState(0)

  const inputBox = useRef(null)
  const scrollDiv = useRef(null)
  const containerDiv = useRef(null)

  const fetchVisibilityOption = () => {
    fetch("/visibility/"+site_key, {
      method: "get",
      headers: {
        "Content-Type": "text/json",
        "Accept": "text/json"
      }
    }).then(response => response.json())
    .then(json => {
      setVisibilityOption(json["option"])
    }).catch(error => {
      // ERROR LOADING VISIBILITY OPTIONS
    })
  }

  useEffect(() => {
    // Scroll to bottom: note: don't put scrollTop in dep array! confusing.
    if(scrollDiv.current.scrollHeight > 30) {
      // A fast user can open the window faster than it loads
      scrollDiv.current.scrollTop = scrollDiv.current.scrollHeight;
      setStarted(true)      
    } else {
      window.addEventListener("resize", e => {
        scrollDiv.current.scrollTop = scrollDiv.current.scrollHeight;
        setStarted(true)
      });      
    }

  }, [setStarted])


  const reloadMessages = () => {
    fetch("/messages/"+site_key+"/"+user_key, {
      method: "get",
      headers: {
        "Content-Type": "text/json",
        "Accept": "text/json"
      }
    }).then(response => response.json())
    .then(json => {
      setMessages(json)
      setLoadingMessages(false)
    }).catch(error => {
      setLoadingMessages(false)
    })
  }

  useEffect(() => {

      if(started && !visibility.current) {
        fetchVisibilityOption()
      }
      if(started && !pusher.current) {
        pusher.current = new Pusher('d51975fd09fb7aa84561', {
          cluster: 'mt1'
        });

        let channel = pusher.current.subscribe(site_key + "_" + user_key);
        channel.bind('message', function(data) {
          reloadMessages()
        })        
      }

  }, [started])

  useEffect(() => {
    reloadMessages()
  }, [site_key, user_key])

  useLayoutEffect(() => {
    if(scrollDiv && scrollDiv.current) {
      scrollDiv.current.scrollTop = scrollDiv.current.scrollHeight;      
    }
  }, [messages, scrollDiv])

  // useLayoutEffect(() => {
  // }, [containerDiv && containerDiv.current && containerDiv.current.getBoundingClientRect().height])

  const sendMessage = (e) => {
    e.preventDefault()
    setLoading(true)

    fetch("/messages/"+site_key+"/"+user_key+"/create", {
      method: "POST",
      headers: {
        "Content-Type": "text/json",
        "Accept": "text/json",
        "X-CSRF-Token": csrftoken
      },
      body: JSON.stringify({
        message: message,
        extra_params: props.extra_params
      })
    }).then(response => response.json())
    .then(json => {
      setLoading(false)
      setMessage("")
      setHeight(0)
      if(json.message) {
        const existing = messages.find(m => m.id == json.message.id)
        if(!existing) {
          setMessages([ ...messages, json.message ])
        }
      }
    }).catch(err => {
      setLoading(false)
      setMessage("")
      setHeight(0)
    })
  }


  const sendEmailMessage = (e) => {
    e.preventDefault()

    if(!email || email == "") {
      setBlankEmailError(true)
      return
    }

    setLoading(true)

    fetch("/messages/"+site_key+"/"+user_key+"/create_email", {
      method: "POST",
      headers: {
        "Content-Type": "text/json",
        "Accept": "text/json",
        "X-CSRF-Token": csrftoken
      },
      body: JSON.stringify({
        message: "[OFFLINE MESSAGE]:" + "\n\n" + message + "\n\n" + "[EMAIL]: " + email,
        extra_params: props.extra_params
      })
    }).then(response => response.json())
    .then(json => {
      setLoading(false)
      setMessage("")
      setEmail("")
      setEmailThankYou(true)
      setHeight(0)
      if(json.message) {
        const existing = messages.find(m => m.id == json.message.id)
        if(!existing) {
          setMessages([ ...messages, json.message ])
        }
      }
    }).catch(err => {
      setLoading(false)
      // setMessage("")
      // setEmail("")
      setHeight(0)
    })
  }

  const setAndResize = (e) => {
    setMessage(e.target.value)
    if(e.target.value == "") {
      setHeight(0)
    } else {
      setHeight(inputBox && inputBox.current ? inputBox.current.scrollHeight : 0)
    }
  }

  const isEnter = e => {
    if (e.key === 'Enter') {
      sendMessage(e)
    }
  }

  let baseMessageCss = "rounded border border-1 px-2 py-0.5 mb-1 text-sm"
  let toCss = baseMessageCss + " border-gray-200 bg-gray-100"
  let fromCss = baseMessageCss
  let toStyle = {overflowWrap: "break-word"}
  let fromStyle = {
                    border: "1px solid " + props.background_color,
                    color: props.icon_color,
                    background: props.background_color,
                    overflowWrap: "break-word"
                  }

  return (
    <div className="flex flex-col flex-grow h-full" ref={containerDiv}>
      <div className="flex flex-col flex-grow p-2" style={{
        overflowY: 'auto',
        overflowWrap: "break-word",
        borderTop: "4px solid "+props.background_color
      }} ref={scrollDiv}>

        {
          visibilityOption == "loading" &&
          <div className="flex items-center justify-center flex-grow flex-col text-center text-gray-400">
            <span className="flex">
              <span className="animate-ping h-8 w-8 rounded-full"
              style={{
                background: props.background_color
              }}
              ></span>
            </span>
          </div>
        }


        {
          !emailThankYou &&
          visibilityOption == "email" &&
          <div>
            
            <p className="text-sm justify-center p-3 pt-1 pb-1 text-gray-700">We are offline right now.</p>
            
            {
              !blankEmailError &&
              <p className="text-sm justify-center p-3 pt-0 pb-4 text-gray-700">Type your message and email address below, and we'll send you an email as soon as we're back online.</p>
            }

            {
              blankEmailError &&
              <p className="text-sm justify-center p-3 pt-0 pb-4 text-red-700">Please enter your email address below so that we can contact you when we get back online.</p>
            }

            <div className="flex">
              <textarea 
                className="flex flex-grow border-t border-gray-300"
                type="text"
                placeholder="Message" 
                value={message}
                onChange={e => setMessage(e.target.value)}
                rows={4}
                style={{ 
                  resize: "none",
                  height: 220,
                  minHeight: 45
                }}
                ref={inputBox}
              />
            </div>

            <div className="flex">
              <input 
                className={"flex flex-grow border-b " + (blankEmailError && (!email || email == "") ? "border-red-700 border-t-1" : "border-gray-300 border-t-0") }
                type="text"
                placeholder="email@example.com" 
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ 
                }}
              />
            </div>



            <div className="flex flex-row justify-end items-end">
              <button 
                className="px-4 mt-2 text-sm" 
                style={{ 
                  height: 45,
                  background: props.background_color,
                  color: props.icon_color
                }}
                onClick={sendEmailMessage}
              >
                Send Message
              </button>
            </div>

          </div>
        }

        {
          emailThankYou &&
          visibilityOption == "email" &&
          <div className="flex flex-col h-full items-center justify-center">
            <p className="text-lg justify-center text-center p-3 pt-1 pb-4 text-gray-800">Thank You!</p>
            <p className="text-sm justify-center text-center p-3 pt-0 pb-4 text-gray-600">We'll get back to you as soon as possible.</p>
          </div>
        }

        {
          visibilityOption == "always" && !loadingMessages && (!messages || messages.length == 0) &&
          <div className="flex items-center justify-center flex-grow flex-col text-center text-gray-400 text-light">
            {props.message}
          </div>
        }


        {
          visibilityOption == "always" && !loadingMessages && messages && messages.map(message => {
            return (
              <div className="flex" key={message.id} style={{
                    overflowWrap: "break-word"
                  }}>
                {
                  message.from_user_key &&
                  <div className="flex flex-grow" style={{ minWidth: 40 }}>
                  &nbsp;
                  </div>
                }

                <div 
                  className={message.to_user_key ? toCss : fromCss}
                  style={message.to_user_key ? toStyle : fromStyle}
                >
                  {message.text.split("\n").map((m, i) => <p key={i}><Emoji text={m} /></p>)}
                </div>
                
                {
                  message.to_user_key &&
                  <div className="flex flex-grow" style={{ minWidth: 40 }}>
                  &nbsp;
                  </div>
                }

              </div>
            )
          })
        }
      </div>






      {
        visibilityOption == "always" &&
        <div className="flex">
          <textarea 
            className="flex flex-grow border-l-0 border-r-0 border-b-0 border-t-1 border-gray-400 text-light placeholder-gray-400"
            type="text"
            placeholder="Type and press enter" 
            value={message}
            onChange={e => setAndResize(e)}
            onKeyDown={e => isEnter(e)}
            rows={1}
            style={{ 
              resize: "none",
              height: height,
              minHeight: 45,
              maxHeight: 150
            }}
            ref={inputBox}
          />
          <div className="flex items-end">
            <button 
              className="px-2 text-sm" 
              style={{ 
                height: 45, 
                color: props.icon_color,
                backgroundColor: props.background_color
              }}
              onClick={sendMessage}
            >
              Send
            </button>
          </div>
        </div>
      }

    </div>
  )
}




document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('chat')
  const data = JSON.parse(node.getAttribute('data'))

  ReactDOM.render(<Chat {...data} />, node)
})

